import httpService from "../../components/service";

export const functionality = {
    namespaced: true,
    state: {
        functionalities: null,
        functionalitiesLight: null,
        applications: null
    },
    getters: {
        getAllFunctionalities(state) {
            return state.functionalities;
        },
        getAllFunctionalitiesLight(state) {
            return state.functionalitiesLight;
        },
        getAllApplications(state) {
            return state.applications;
        }
    },
    mutations: {
        FIND_ALL_FUNCTIONALITIES(state, functionalities) {
            state.functionalities = functionalities;
        },
        FIND_ALL_FUNCTIONALITIES_LIGHT(state, functionalities) {
            state.functionalitiesLight = functionalities;
        },
        FIND_ALL_APPLICATIONS(state, applications) {
            state.applications = applications;
        }
    },
    actions: {
        findAllFunctionalities(context) {
            return httpService.get("/functionalities").then(res => {
                if (httpService.hasError(res)) return false;
                context.commit("FIND_ALL_FUNCTIONALITIES", res);
                let funcSimple = [];

                res.forEach(func => {
                    funcSimple.push(func.name);
                });
                context.commit("FIND_ALL_FUNCTIONALITIES_LIGHT", funcSimple);
                return res;
            });
        },
        findAllApplications(context) {
            return httpService.get("/applications").then(res => {
                if (httpService.hasError(res)) return false;
                context.commit("FIND_ALL_APPLICATIONS", res);
                return res;
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/user/functionality.js